// src/pages/HomePage.tsx
import '../styles/Home.css';
import HomePageSlider from '../components/HomePageSlider';
import HomePageSlideMessage from '../components/HomePageSlideMessage';
import HomeSlideSectionA from '../components/HomeSlideSectionA';
import HomeSlideSectionB from '../components/HomeSlideSectionB';
import Meta from '../components/Meta';
import HomeSlideServices from '../components/HomeSlideServices';

const HomePage = () => {
    return (

        <div className=''>
            <Meta title={'Inicio'} />

            <HomePageSlider />

            <div className='bodyHomePage container-xxxl '>

                <HomePageSlideMessage />
                <HomeSlideSectionA />
                {/*<HomeSlideAliados /> */}
                <HomeSlideServices />
                <HomeSlideSectionB />

            </div>
        </div>
    )
};

export default HomePage;